/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997Module
 * Purpose		: Module for CategorySalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { CategorySalesfor1997Service } from './CategorySalesfor1997.service';
import { CategorySalesfor1997ListComponent } from './CategorySalesfor1997List.component';
import { CategorySalesfor1997SearchComponent } from './CategorySalesfor1997Search.component';
import { CategorySalesfor1997DetailsComponent } from './CategorySalesfor1997Details.component';

import { CategorySalesfor1997RoutingModule } from './CategorySalesfor1997-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    CategorySalesfor1997RoutingModule
  ],
  declarations: [
    CategorySalesfor1997ListComponent,
	CategorySalesfor1997SearchComponent,
	CategorySalesfor1997DetailsComponent
  ],
  providers: [
    CategorySalesfor1997Service
  ]
})

export class CategorySalesfor1997Module { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CategorySalesfor1997/CategorySalesfor1997.module.ts